import Vue from "vue";
import { Entity, RawEntity } from "@/entities";
import Pageable from "@/entities/pageable/pageable_collection";
import {
  BACKEND_BASE_URL,
  BACKEND_BASE_URL_READS,
  EntityService,
  ResponseCreate,
  ResponseCreateV2,
  SearchEntitiesRequest,
} from "@/services";
import { RawPage } from "@/entities/pageable/pageable_types";
import { AxiosResponse } from "axios";

export class EntityServiceImpl implements EntityService {
  async fetchEntities(map: Record<string, unknown>): Promise<Pageable<Entity>> {
    const { data } = await Vue.$axios.post<RawPage<RawEntity>>(`${BACKEND_BASE_URL_READS}/api/v1/me/entities`, map);
    if (!data.results && data.projections) {
      data.results = data.projections;
    }
    return {
      totalResult: data.totalResult,
      results: data.results?.map((rawEntity) => new Entity(rawEntity)) ?? [],
    };
  }
  
  async fetchEntitiesV2(request: SearchEntitiesRequest): Promise<Pageable<Entity>> {
    const { data } = await Vue.$axios.post<RawPage<RawEntity>>(`${BACKEND_BASE_URL_READS}/api/v2/me/entities`, request);
    if (!data.results && data.projections) {
      data.results = data.projections;
    }
    return {
      totalResult: data.totalResult,
      results: data.results?.map((rawEntity) => new Entity(rawEntity)) ?? [],
    };
  }
  
  async updateEntity(entity: Entity): Promise<void> {
    await Vue.$axios.put<void>(`${BACKEND_BASE_URL}/api/v2/entities/${entity.id}`, {
      name: entity.name,
      active: entity.active,
    });
  }

  async createEntity(entity: Entity): Promise<ResponseCreateV2> {
    const { data } = await Vue.$axios.post<ResponseCreateV2>(`${BACKEND_BASE_URL}/api/v2/entity`, {
      name: entity.name,
      code: entity.code,
      countryCode: entity.countryCode,
    });
    return data;
  }

  async changeStatus(entity: Entity): Promise<void> {
    await Vue.$axios.patch<AxiosResponse>(`${BACKEND_BASE_URL}/api/v1/entity/${entity.id}`, {
      active: entity.active,
    });
  }
}
